module.exports = ".project-logo{max-width:200px}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/project-column/project-column.component.scss
// module id = ./src/app/shared/project-column/project-column.component.scss
// module chunks = main